import React from "react";
import { Integration } from "../../../types/integration";
import { DefaultColumnBuilder as builder } from "../../components/ColumnBuilder";
import { Button, Popconfirm, Space, Table } from "antd";
import { AnyObject } from "antd/es/_util/type";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";

export interface IntegrationTableProps {
  loading?: boolean;
  records: Integration[];
  onEdit?: (id: number) => void;
  onDelete?: (id: number) => void;
}

export const IntegrationTable = (props: IntegrationTableProps) => {
  const columns = [
    builder.id,
    { ...builder.text("Artifact", "artifact"), width: 260 },
    builder.text("Version", "version"),
    builder.text("Source", "source"),
    builder.text("Min OS", "deploymentTarget"),
    builder.text("Comment", "comment"),
    {
      title: "Actions",
      key: "actions",
      width: 90,
      fixed: "right" as const,
      render: (_: unknown, record: AnyObject) => (
        <Space size="small">
          {props.onEdit && (
            <Button
              type="text"
              icon={<EditOutlined />}
              aria-label={`Edit integration ${record.artifact}`}
              onClick={() =>
                record.id !== undefined && props.onEdit?.(record.id)
              }
            />
          )}
          {props.onDelete && (
            <Popconfirm
              title="Delete integration"
              description={`Remove the integration "${record.artifact}" (${record.version})?`}
              okText="Yes"
              cancelText="No"
              onConfirm={() => props.onDelete?.(record.id)}
            >
              <Button
                type="text"
                danger
                icon={<DeleteOutlined />}
                aria-label={`Delete integration ${record.artifact}`}
              />
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];

  return (
    <Table
      loading={props.loading}
      columns={columns}
      pagination={false}
      scroll={{ x: "max-content" }}
      dataSource={(props.records || []).map((record) => ({
        ...record,
        key: record.id,
      }))}
    />
  );
};
